import type { IconData } from '@stacksjs/iconify-core'

export const chevronCircleUpAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M256 496A240 240 0 0 1 86.294 86.294a240 240 0 0 1 339.412 339.412A238.43 238.43 0 0 1 256 496m0-448C141.309 48 48 141.309 48 256s93.309 208 208 208s208-93.309 208-208S370.691 48 256 48\"/><path fill=\"currentColor\" d=\"M356.686 315.313L256 214.628L155.314 315.313l-22.628-22.626L256 169.373l123.314 123.314z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default chevronCircleUpAlt
